<template>
	<login-user :role="role" :sysName="$config.sysName+'-后台管理'" :isAdminLogin='true' :bgUrl='bgUrl'></login-user>
</template>

<script>
	// import loginUser from '@/components/login/userLogin_jhskj.vue'
	import loginUser from '@/components/login/userLogin.vue'
	export default {
		data() {
			return {
				role: [1, 2, 3, 4],
				sysName: '',
				bgUrl: '/img/banner.png'
			}
		},
		created() {
			this.sysName = this.$config.sysName
			 
			
			switch (this.$config.sysID) {
				case 2:
					// this.bgUrl = '/img/jhskj/login/bg.png'
					break;
				default:
					break;
			}
		},
		components: {
			loginUser
		}
	}
</script>

<style>
</style>
